import React, {useState, useRef, useEffect} from 'react';
import post from '../utils/post.js';
import FormTextArea from './FormTextArea.js';
import FormText from './FormText.js';
import ConfirmPopup from './ConfirmPopup.js';
import usePopupAnimation from '../utils/usePopupAnimation.js';

export default function NoteEdit({showEdit, closeEdit, updateNoteRowEdit, updateNoteRowDelete, data}) {
	const popupAnimationMs = 300;
	const [loading, setLoading] = useState(false);
	const [note, setNote] = useState('');
	const [noteError, setNoteError] = useState('');
	const [name, setName] = useState('');
	const [nameError, setNameError] = useState('');
	const nameRef = useRef(null);
	const [sortorder, setSortorder] = useState(1);
	const [sortorderError, setSortorderError] = useState('');
	const sortorderRef = useRef(null);
	const [showConfirmPopup, setShowConfirmPopup] = useState(false);

	const noteRef = useRef(null);
	const {shouldRender, isClosing} = usePopupAnimation(showEdit, popupAnimationMs);

	useEffect(() => {
		setNote(data.NOTE || '');
		setName(data.NAME || '');
		setSortorder(data.SORTORDER || 1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showEdit]);

	useEffect(() => {
		setNote(data.NOTE || '');
		setNoteError('');
		setName(data.NAME || '');
		setNameError('');
		setSortorder(data.SORTORDER || 1);
		setSortorderError('');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	const handleSubmit = (e) => {
		e.preventDefault();

		setNoteError('');
		setNameError('');

		let localError = 0;

		if (!note) {
			localError = 1;
			setNoteError('povinné');
			noteRef.current.focus();
		}

		if (!name) {
			localError = 1;
			setNameError('povinné');
			nameRef.current.focus();
		}

		if (localError === 0) {
			setLoading(true);

			post('saveNoteOld', {SORTORDER: sortorder, NAME: name, NOTE: note, ID: data.ID})
				.then((res) => {
					closeEdit();
					updateNoteRowEdit({ID: data.ID, CRDTS: data.CRDTS, SORTORDER: sortorder, NAME: name, NOTE: note, NOTES: res.NOTES});
					setLoading(false);
				})
				.catch((error) => {
					console.error(error);
					setLoading(false);
				});
		}
	};

	const handleConfirmPopup = (e) => {
		e.preventDefault();
		setShowConfirmPopup(true);
	};

	const closeConfirmPopup = () => {
		setShowConfirmPopup(false);
	};

	const deleteConfirmPopup = () => {
		setLoading(true);

		post('deleteNote', {ID: data.ID})
			.then((res) => {
				closeConfirmPopup();
				closeEdit();
				updateNoteRowDelete(data.ID);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	return (
		<>
			<ConfirmPopup showConfirmPopup={showConfirmPopup} showButtonDelete deleteConfirmPopup={deleteConfirmPopup} closeConfirmPopup={closeConfirmPopup} infoHeader="Smazání záznamu" infoMain="Opravdu chceš smazat tento záznam?" />

			{shouldRender ? (
				<div className={`popup${isClosing ? ' popup--closing' : ''}`}>
					<div className={`popup_content${isClosing ? ' popup_content--closing' : ''}`}>
						<form method="POST" onSubmit={handleSubmit}>
							<div className="popup_content_in_head">
								<div className="popup_content_in_head_in">Editace poznámky</div>
								<img
									alt=""
									className="popup_content_in_head_in-close"
									onClick={() => {
										closeEdit();
									}}
								/>
							</div>
							<div className="popup_content_in_body">
								<div className="popup_content_in_body_in">
									<div className="fl_l" style={{width: '48%'}}>
										<FormText type="text" label="Pořadí" value={sortorder} setValue={setSortorder} ref={sortorderRef} error={sortorderError} />
									</div>
									<div className="fl_r" style={{width: '48%'}}>
										
									</div>
									<div className="zero h0" />

									<FormText type="text" label="Název" value={name} setValue={setName} ref={nameRef} error={nameError} />
									<div className="zero h0" />

									<FormTextArea type="text" label="Poznámka" height="25rem" value={note} setValue={setNote} ref={noteRef} error={noteError} />
									<div className="zero h0" />
								</div>
							</div>
							<div className="popup_content_in_foot">
								<div className="popup_content_in_foot_in">
									<input type="submit" name="button_save" value="Uložit" className="button green mr_2" disabled={loading} />
									<button
										type="button"
										className="button red mr_2"
										onClick={(e) => {
											handleConfirmPopup(e);
										}}
									>
										Smazat
									</button>
									<button
										type="button"
										className="button"
										onClick={() => {
											closeEdit();
										}}
									>
										Zpět
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			) : (
				''
			)}
		</>
	);
}
